<template>
  <div class="box">
    <span class="ja">・・・表示準備中・・・<br /></span>
    <span class="en">not ready</span>
  </div>
</template>

<style scoped>
.box {
  position: relative;
  text-align: center;
  width: 100vw;
  height: 50vh;
  top: 30vh;
}
.ja {
  font-weight: bold;
  font-size: 3.5rem;
  color: white;
}
.en {
  font-weight: bold;
  font-size: 2rem;
  color: white;
}
</style>